<div>
  正しい証明書が選択されていません。
  すべてのアプリ・ブラウザを終了させ、ConnectOnlineのみ再度起動し、正しい証明書を選択してください。
</div>
